var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { style: { height: "100%" } },
    [
      _c(
        "app-chat-conversation",
        {
          key: _vm.conversation.ID,
          attrs: { conversation: _vm.conversation, state: _vm.state },
        },
        [
          _vm._t(
            "header",
            function () {
              return [
                _c("w-switch", {
                  attrs: { label: "Toggle bubbles" },
                  model: {
                    value: _vm.state.settings.BubbleStyle,
                    callback: function ($$v) {
                      _vm.$set(_vm.state.settings, "BubbleStyle", $$v)
                    },
                    expression: "state.settings.BubbleStyle",
                  },
                }),
                _c("w-spacer"),
                _c(
                  "w-button",
                  {
                    attrs: { flat: "", icon: ["far", "comment-dots"] },
                    on: { click: _vm.toggleNewThread },
                  },
                  [_vm._v(" " + _vm._s(_vm.$ct("new-conversation")) + " ")]
                ),
              ]
            },
            { slot: "header" }
          ),
        ],
        2
      ),
      _c("app-thread-modal", {
        attrs: { state: _vm.state },
        model: {
          value: _vm.showAddThreadModal,
          callback: function ($$v) {
            _vm.showAddThreadModal = $$v
          },
          expression: "showAddThreadModal",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }